/**
 * Checks if a value is a string.
 *
 * This function determines whether the provided value is of type `string` or an instance of `String`.
 *
 * @param value - The value to check.
 * @returns `true` if the value is a string, otherwise `false`.
 */
export const isString = (value: unknown): value is string =>
  typeof value === "string" || value instanceof String;
